import request from '../utils/request';

// 分页查询商家入驻申请列表
export function listMerchantEntryApplications(params) {
  return request({
    url: '/merchant-entry-application/list',
    method: 'get',
    params: {
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      status: params.status,
      businessName: params.businessName,
      userId: params.userId,
      startTime: params.startTime,
      endTime: params.endTime,
      sortField: params.sortField || 'create_time',
      sortOrder: params.sortOrder || 'desc'
    }
  });
}

// 审核商家入驻申请
export function auditMerchantEntryApplication(applicationId, status, rejectReason) {
  return request({
    url: '/merchant-entry-application/audit',
    method: 'put',
    params: {
      applicationId,
      status,
      rejectReason
    }
  });
}
